<template>
  <div class="navigation-content">
    <div
      class="form__pagination__chevron"
      :class="{ disabled: isOfferSubmitted }"
      @click="previousPage"
    >
      <i class="material-icons" aria-label="forrige">chevron_left</i>
      <span>Forrige</span>
    </div>
    <div class="desktop form__pagination alignfull">
      <div
        class="form__pagination--page"
        :class="{
          'form__pagination--page-progress': index <= currentPageIndex,
          'form__pagination--page-valid':
            index < currentPageIndex ||
            (currentPageIndex === 5 && isOfferSubmitted),
        }"
        :key="index"
        v-for="(page, index) of pages"
        @click="skipTo(index)"
      >
        <i>
          <svg id="check" viewBox="0 0 24 24">
            <path
              fill="#fff"
              d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"
            />
          </svg>
        </i>
        <span>{{ page.name }}</span>
      </div>
    </div>

    <div class="mobile">
      <div
        class="mobile-pagination"
        :class="{ 'mobile-pagination-progress': index <= currentPageIndex }"
        v-for="(page, index) of pages"
        :key="index"
      ></div>
    </div>

    <div
      class="form__pagination__chevron form__pagination__chevron--right"
      :class="{ disabled: isNextButtonDisabled }"
      @click="nextPage"
    >
      <span>{{ nextButtonText }}</span>
      <i
        class="material-icons"
        :style="{ opacity: isOfferSubmitted ? 0 : 1 }"
        aria-label="neste"
        >chevron_right</i
      >
      <!-- TODO: Fix placement of this. <div v-if="currentPageIndex === 4 && !customerInformationValid" class="tooltip">Kontrollér skjema</div> -->
    </div>

    <div
      class="modal"
      :class="{ 'is-visible': showErrorModal }"
      id="modal1"
      @keyup.esc="showErrorModal = false"
      @click.self="showErrorModal = false"
    >
      <div class="modal-dialog">
        <header class="modal-header">
          En feil oppsto
          <button
            type="button"
            class="close-modal"
            aria-label="close modal"
            @click="showErrorModal = false"
          >
            ✕
          </button>
        </header>
        <section class="modal-content">
          <legend class="h4">En feil oppsto</legend>
          <div v-html="errorMessage"></div>
        </section>
      </div>
    </div>
    <!--TODO: Implement this in a good way. <div v-show="currentPageIndex === 0" class="confused">
            <a href="https://solkraft.hkraft.no/solkart-skjema/">
                Finner du ikke taket ditt?
                Ta kontakt via skjema.
            </a>
    </div>-->
  </div>
</template>

<script>
import store from '../store';
export default {
  name: 'Navigation',
  components: {},
  data() {
    return {
      hasChanged: true,
      showErrorModal: false,
    };
  },
  mounted() {
    this.$root.$on('navigateToNextPage', () => {
      this.nextPage();
    });

    this.$root.$on('navigateToPreviousPage', () => {
      this.previousPage();
    });
  },
  methods: {
    previousPage() {
      if (this.isOfferSubmitted) {
        store.commit('resetOfferSubmission');
      }

      if (this.currentPageIndex > 0) {
        this.currentPageIndex--;
      }

      this.scrollToTop();
    },
    nextPage: function() {
      if (
        !this.roof ||
        (this.currentPageIndex === 4 && !this.customerInformationValid) ||
        (this.currentPageIndex === 5 && !this.agreedToTerms) ||
        this.isOfferSubmitted ||
        this.isNextButtonDisabled
      ) {
        return;
      }

      if (this.currentPageIndex === 2) {
        this.calculateOffer();
      } else if (this.currentPageIndex === 5) {
        this.submitOffer();
      } else {
        this.currentPageIndex++;
        this.scrollToTop();
      }
    },
    skipTo: function(index) {
      if (
        !this.roof ||
        (index > 0 && !this.pages[index - 1].visited) ||
        (index === 5 && !this.customerInformationValid) ||
        this.isOfferSubmitted ||
        (!Object.keys(this.panel).length && index > 3)
      ) {
        return;
      }

      this.currentPageIndex = index;
    },
    submitOffer: function() {
      store.commit('setLoadingText', 'Sender inn henvendelse...');
      store.commit('setIsLoading', true);
      store
        .dispatch('submitOffer')
        .then(() => {
          store.commit('setIsLoading', false);
          this.isOfferSubmitted = true;

          if (window.dataLayer) {
            const offerValue =
              this.customerType.value === 'privat'
                ? this.panel.pris - this.panel.enovaStotte
                : this.panel.pris;
            window.dataLayer.push({
              event: 'send_order',
              value: offerValue,
            });
          }
        })
        .catch(() => {
          this.errorMessage =
            '<p>Det oppsto en feil under innsendingen. Vennligst prøv igjen senere eller ta kontakt via <a href="https://solkraft.hkraft.no/solkart-skjema/">skjema</a></p>';
          this.showErrorModal = true;
          store.commit('setIsLoading', false);
        });
    },
    calculateOffer: function() {
      if (
        store.state.offers.hasOwnProperty(
          'roofTypeId_' + store.state.roofType.id
        ) &&
        store.state.offers[
          'roofTypeId_' + store.state.roofType.id
        ].hasOwnProperty('panelTypeId_' + store.state.solarPanelType.id)
      ) {
        this.currentPageIndex++;
        this.scrollToTop();
        return;
      }
      store.commit('setLoadingText', 'Beregner tilbud...');
      store.commit('setIsLoading', true);

      if (this.hasChanged) {
        store
          .dispatch('getOfferFromBackend')
          .then(result => {
            if (result.paneler.length > 0) {
              this.currentPageIndex++;
              this.scrollToTop();
              this.hasChanged = false;
            } else {
              this.errorMessage =
                '<p>Kan ikke beregne tilbud for denne konfigurasjonen. Vennligst ta kontakt via <a href="https://solkraft.hkraft.no/solkart-skjema/">skjema</a> eller prøv igjen med andre valg.</p>';
              this.showErrorModal = true;
              this.scrollToTop();
            }
            store.commit('setIsLoading', false);
          })
          .catch(() => {
            this.errorMessage =
              '<p>Det oppsto en feil i beregningen. Vennligst ta kontakt via <a href="https://solkraft.hkraft.no/solkart-skjema/">skjema</a></p>';
            this.showErrorModal = true;
            store.commit('setIsLoading', false);
            this.scrollToTop();
          });
      } else {
        this.currentPageIndex++;
        this.scrollToTop();
        store.commit('setIsLoading', false);
      }
    },
    scrollToTop() {
      window.scroll({
        top: 0,
        left: 0,
        behavior: 'smooth',
      });
    },
  },
  computed: {
    currentPageIndex: {
      get() {
        return store.state.currentPageIndex;
      },
      set(value) {
        store.commit('setCurrentPageIndex', value);
        history.pushState({ currentPageIndex: value }, null, null);
      },
    },
    errorMessage: {
      get() {
        return store.state.errorMessage;
      },
      set(value) {
        store.commit('setErrorMessage', value);
      },
    },
    roof() {
      return store.state.roof;
    },
    customerInformationValid() {
      return store.state.CustomerInformationValid;
    },
    isOfferSubmitted: {
      get() {
        return store.state.isOfferSubmitted;
      },
      set(value) {
        store.commit('setIsOfferSubmitted', value);
      },
    },
    pages() {
      return store.state.pages;
    },
    agreedToTerms() {
      return store.state.CustomerInformation.agreedToTerms;
    },
    customerType() {
      return store.state.CustomerType;
    },
    panel() {
      return store.state.panelsVal;
    },
    isNextButtonDisabled() {
      return (
        !this.roof ||
        (this.currentPageIndex === 4 && !this.customerInformationValid) ||
        (this.currentPageIndex === 5 && !this.agreedToTerms) ||
        this.isOfferSubmitted ||
        (this.currentPageIndex === 3 && !this.panel.pris)
      );
    },
    nextButtonText() {
      return store.getters.nextButtonText;
    },
  },
  watch: {
    roofType() {
      this.hasChanged = true;
    },
    solarPanelType() {
      this.hasChanged = true;
    },
    roof() {
      this.hasChanged = true;
    },
    selectedCustomerType() {
      this.hasChanged = true;
    },
  },
};
</script>

<style scoped>
.navigation .navigation-content {
  display: flex;
  justify-content: space-between;
  background-color: #003451;
  height: 4rem;
}

@media (min-width: 48em) {
  .navigation .navigation-content {
    justify-content: center;
  }
}

.navigation .navigation-content .confused {
  max-width: 60vw;
  color: #333;
  font-size: 90%;
}

.navigation .navigation-content .buttons {
  margin-right: 0.2em;
}

@media (max-width: 75.99em) {
  .mobile {
    display: flex;
    align-items: center;
  }

  .mobile .mobile-pagination {
    border-radius: 50%;
    background-color: #fff;
    width: 0.75rem;
    height: 0.75rem;
    margin: 0 0.25rem;
    opacity: 0.5;
  }

  .mobile .mobile-pagination.mobile-pagination-progress {
    opacity: 1;
  }

  .desktop {
    display: none !important;
  }
}

@media (min-width: 76em) {
  .mobile {
    display: none;
  }

  .form__pagination__chevron {
    margin: 0 !important;
  }
}

.form__pagination {
  background-color: #003451;
  padding-top: 0.8rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

.form__pagination--page {
  padding: 1.2rem 0.8rem 0.8rem 0.8rem;
  color: #fff;
}

@media (max-width: 47.99em) {
  .form__pagination--page {
    padding: 1.2rem;
  }
}

.form__pagination--page i {
  border-color: #e8f2fa;
  background-color: #003451;
  height: 24px;
  width: 24px;
  box-shadow: 0 0 15px rgba(0, 0, 0, 1);
}

.form__pagination--page i svg {
  width: 14px;
  height: 14px;
}

.form__pagination--page i svg path {
  fill: #003451;
}

.form__pagination--page:not(:last-child):after {
  background-color: #e8f2fa;
  top: 11px;
}

.form__pagination--page-valid {
  cursor: pointer;
}

.form__pagination--page-progress i {
  background-color: #e8f2fa !important;
}

.form__pagination__chevron {
  display: flex;
  align-items: center;
  color: #fff;
  width: 7rem;
  margin: auto;
  cursor: pointer;
}

@media (min-width: 48em) {
  .form__pagination__chevron {
    margin: 0 calc(22.5px + 2em);
  }
}

.form__pagination__chevron--right {
  justify-content: flex-end;
}

.form__pagination__chevron span {
  text-transform: uppercase;
  font-weight: 600;
  position: relative;
  top: 0.1rem;
}

.form__pagination__chevron i {
  font-size: 28px;
  cursor: pointer;
  text-shadow: 0 0 10px rgba(0, 0, 0, 1);
}

.form__pagination__chevron.disabled {
  opacity: 0.5 !important;
}

.form__pagination__chevron.disabled i + .tooltip {
  animation: none;
  width: fit-content;
}

.form__pagination__chevron.disabled:hover i + .tooltip {
  opacity: 1;
}
</style>
